import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class SettingModel extends BaseModel {

    constructor() {
        super({ 
                name: "setting",
                tableName: 'setting', 
                label: "Cài đặt", 
                display_key: 'name', 
                default_order: { key: 'id', direction: 'asc' } }, 
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                description: {
                    name: 'description',
                    type: "String",
                    class: "center",
                    label: 'Tên cài đặt',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                code: {
                    name: 'code',
                    type: "String",
                    display: false,
                },
                value: {
                    name: 'value',
                    type: "String",
                    class: "center",
                    label: 'Thực hiện / ngày',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
            },
        )
    }

}